import { URL_JUSBRASIL } from '../../static-fields'
import { SEOPotentialAction, SEOWebsite } from '../../types'
import { makeId } from '../utils'

export interface SEOWebsiteInput {
  name: string
  description: string
  canonicalUrl: string
  potentialAction: SEOPotentialAction
}

export const getWebSite = ({
  name,
  description,
  canonicalUrl,
  potentialAction,
}: SEOWebsiteInput): SEOWebsite => {
  return {
    '@type': 'WebSite',
    '@id': makeId(canonicalUrl, 'website'),
    name,
    url: canonicalUrl,
    description,
    publisher: {
      '@id': makeId(URL_JUSBRASIL, 'organization'),
    },
    potentialAction: potentialAction,
    hasPart: {
      '@id': makeId(canonicalUrl, 'navigation'),
    },
  }
}
